import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wellth_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  register: (data) => api.post('/auth/register', data).then((r) => r.data),
  login: (data) => api.post('/auth/login', data).then((r) => r.data),
  me: () => api.get('/auth/me').then((r) => r.data),
  google: (session_id) => api.post('/auth/google', { session_id }).then((r) => r.data),
};

export const voiceApi = {
  transcribe: (blob) => {
    const fd = new FormData();
    fd.append('audio', blob, 'speech.webm');
    return api.post('/voice/transcribe', fd).then((r) => r.data.text);
  },
};

export const intakeApi = {
  analyze: (payload) => api.post('/intake/analyze', payload).then((r) => r.data),
};

export const reportsApi = {
  list: () => api.get('/reports').then((r) => r.data),
  get: (id) => api.get(`/reports/${id}`).then((r) => r.data),
  attach: (payload) => api.post('/reports/attach', payload).then((r) => r.data),
};

export const streakApi = {
  ping: () => api.post('/streak/ping').then((r) => r.data),
};

export const trackerApi = {
  today: () => api.get('/tracker/today').then((r) => r.data),
  summary: () => api.get('/tracker/summary').then((r) => r.data),
  analyze: (payload) => api.post('/tracker/analyze', payload).then((r) => r.data),
  analyzeText: (text) => api.post('/tracker/analyze-text', { text }).then((r) => r.data),
  log: (payload) => api.post('/tracker/log', payload).then((r) => r.data),
  deleteLog: (id) => api.delete(`/tracker/log/${id}`).then((r) => r.data),
  setGoals: (payload) => api.put('/tracker/goals', payload).then((r) => r.data),
  barcode: (code) => api.get(`/tracker/barcode/${code}`).then((r) => r.data),
  frequentFoods: () => api.get('/tracker/frequent-foods').then((r) => r.data),
};

export const coachApi = {
  chat: (payload) => api.post('/coach/chat', payload).then((r) => r.data),
  listRoutines: () => api.get('/coach/routines').then((r) => r.data),
  saveRoutine: (payload) => api.post('/coach/routines', payload).then((r) => r.data),
  deleteRoutine: (id) => api.delete(`/coach/routines/${id}`).then((r) => r.data),
};

export const avatarApi = {
  generate: (payload) => api.post('/avatar/generate', payload).then((r) => r.data),
  latest: () => api.get('/avatar/latest').then((r) => r.data),
};
